import axios from 'axios';
import AxiosBase from '@/auth/axiosBase';
const baseUrl = process.env.VUE_APP_BACKEND_URL;
export default class RefreshTokenService extends AxiosBase {
    constructor() {
      super();
    }
    async refreshToken  ()  {
       
        let processResult = {}; // login fail
        let url = `${baseUrl}/api/Identity/RefreshToken/GenerateRefreshToken`;
        await axios.post(url)
          .then((response) => {
            processResult = response; 
    
          }).catch((error) => {
            console.log(error);
          });
        return processResult;
      }
}